import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { Placement } from '@/models/Placement';
import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { Color, Tooltip } from './Tooltip';

type InfoTooltipProps = {
  text: string | ReactNode;
  children: ReactNode;
  condition?: boolean;
  color?: Color;
  placement?: Placement;
  classNames: Pick<ClassNameComponent, 'base' | 'icon'>;
  testId?: string;
};

export default function InfoTooltip({
  text,
  children,
  condition = false,
  color = 'purple',
  placement = 'right',
  classNames,
  testId,
}: InfoTooltipProps) {
  if (condition) return <>{children}</>;

  return (
    <div className={twMerge('flex items-center gap-2', classNames.base)}>
      {children}
      <Tooltip
        text={text}
        color={color}
        placement={placement}
        testId={testId}
        className="max-w-xs"
      >
        <QuestionMarkCircleIcon
          className={twMerge('w-6 h-6 text-secondary', classNames.icon)}
        />
      </Tooltip>
    </div>
  );
}
